<template>
  <vs-table :data="data">
    <template slot="header">
      <add-button :btnText="$t('add')" @click="add" />
      <div class="con-input-search vs-table--search">
        <input class="input-search vs-table--search-input" type="text" v-model="text" @keypress.enter="search" />
        <vs-icon icon="search"></vs-icon>
      </div>
      <!-- <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-filter" class="mx-2" radius @click="openFilter"></vs-button> -->
    </template>
    <template slot="thead">
      <!-- <th class="qb-sticky" :style="{background:'white'}"></th> -->
      <th-sort :text="$t('client') | capitalize" column="Clients.ClientName" @sort="handleClickSort" />
      <th-sort :text="$t('company') | capitalize" column="com.CompanyName" @sort="handleClickSort" />
      <th-sort :text="$t('warehouse_code') | capitalize" column="Clients.code" @sort="handleClickSort" />
      <th :text="$t('schedule_day_invoice') | capitalize"></th>
      <th-sort :text="$t('darwin_account') | capitalize" column="Clients.DarwinAccount" @sort="handleClickSort" />
      <th-sort :text="$t('is_active') | capitalize" column="Clients.IsActive" @sort="handleClickSort" />
      <th-sort :text="$t('locked') | capitalize" column="Clients.locked" @sort="handleClickSort" />
      <th-sort :text="$t('color') | capitalize" column="Clients.color" @sort="handleClickSort" />
      <th class="qb-sticky">
        {{ $t('actions') }}
      </th>
    </template>
    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].ClientName }}
        </vs-td>
        <vs-td>
          {{ data[i].CompanyName }}
        </vs-td>
        <vs-td>
          {{ data[i].code }}
        </vs-td>
        <vs-td>
          {{ data[i].InvoiceDay }}
        </vs-td>
        <vs-td>
          {{ data[i].DarwinAccount }}
        </vs-td>
        <vs-td>
          <vs-checkbox :checked="data[i].IsActive == 1" icon="icon-check" icon-pack="feather"
            :disabled="true"></vs-checkbox>
        </vs-td>
        <vs-td>
          <vs-switch success v-model="data[i].lock" @input="lock(data[i])" />
        </vs-td>
        <vs-td>
          <div :style="{ borderRadius: '7px', width: '35px', height: '20px', background: data[i].color }"></div>
        </vs-td>
        <vs-td class="text-center">
          <action-icon icon="ArrowRightCircleIcon" :tooltip="$t('details')" @click="showDetails(data[i].ClientId)" />
        </vs-td>
        <!-- <vs-td>
            <div> -->
        <!-- <action-pdf-viewer :files="[data[i].file]"/> -->
        <!-- <action-icon icon="EditIcon" :tooltip="$t('edit')" />
              <action-icon icon="FileIcon" :tooltip="$t('file')" /> -->
        <!-- </div>
          </vs-td> -->
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import ActionPdfViewer from '@/views/components/actions/ActionPdfViewer'
import AddButton from '@/views/components/buttons/AddButton.vue'
import mixins from '@/mixins'
export default {
  components: {
    AddButton,
    ActionIcon,
    ThSort,
    ActionPdfViewer
  },

  data: () => ({
    text: '',
  }),

  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore');
    },

    search() {
      this.$emit('search', this.text);
    },

    handleClickSort(e) {
      this.$emit('sort', e);
    },

    openFilter() {
      this.$emit('openFilter');
    },
    lock(item) {
      this.$emit('lock', { id: item.ClientId, lock: item.lock })
    },

    showDetails(id) {

      this.$router.push({
        name: 'client-details',
        params: {
          id: id
        }
      });
    },

    add() {
      this.$emit('add');
    }
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style></style>
